export enum EUserBankQueryKey {
  GET = 'get-bank',
  CREATE = 'create-bank',
  UPDATE = 'update-bank',
  DELETE = 'delete-bank',
  SET_DEFAULT = 'set-default-bank',
}
